import { createBusinessMessageMutation } from '../mutations';

const postSingleMessage = async (client, payload, addToast) => {
  try {
    await client.mutate({
      mutation: createBusinessMessageMutation(),
      variables: { input: payload }
    });

    if (addToast) {
      addToast('Message sent successfully', {
        appearance: 'success',
        autoDismiss: true
      });
    }

    return true;
  } catch ({ message }) {
    if (message.toLowerCase().includes('blocked')) {
      if (addToast) {
        addToast('Message sent successfully', {
          appearance: 'success',
          autoDismiss: true
        });
      }
      return false;
    }

    if (addToast) {
      addToast(message, {
        appearance: 'error',
        autoDismiss: true
      });
    }

    return false;
  }
};

const postContactMessages = async (
  client,
  formData,
  yachtData,
  contacts,
  addToast,
  transactionId = ''
) => {
  const payloads = (contacts || []).map(contact => ({
    brokerBranchId: contact.brokerBranchId,
    brokerId: contact.brokerId,
    brokerName: contact.brokerName,
    businessContactId: contact.businessContactId,
    email: formData.email,
    exhibitorId: contact.exhibitorId,
    isSponsored: (yachtData || {}).isSponsored,
    listingState: (yachtData || {}).promotionType,
    message: formData.message,
    messageType: formData.messageType,
    name: formData.name,
    phone: formData.phone,
    transactionId,
    urlSentFrom: ((window || {}).location || {}).href || '',
    yachtForCharterId: (yachtData || {}).yachtForCharterId,
    yachtForSaleId: (yachtData || {}).yachtForSaleId,
    yachtPageId: (yachtData || {}).yachtPageId
  }));

  const results = await Promise.all(
    payloads.map(payload => postSingleMessage(client, payload, addToast))
  );

  return results.every(result => result);
};

export default postContactMessages;
